
<!-- Характеристики этажей -->

<template>

<elements ref="elements"
	style="min-height: 100%;"
	single_element_url="floor_height"
	:service="service"
	:attrs="attrs"
	show_attrs_tooltip="Выбор параметров"
	show_attrs_title="Отображение параметров расчета строительного объема"
	essence_name_genetive_case="данных для расчета строительного объема"
	essence_name_for_plural_1="данные для расчета строительного объема"
	essence_name_for_plural_234="данные для расчета строительного объема"
	essence_name_for_plural_others="данные для расчета строительного объема"
	initial_sort_by="functional_sub_group"
	:without_add="$root.not_editable || ! check_roles([ 'model' ])"
	:with_attr_edit_many="!$root.not_editable && check_roles([ 'model' ])"
	:with_delete_many="!$root.not_editable && check_roles([ 'model' ])"
	:with_import_add="!$root.not_editable && check_roles([ 'model' ])"
	:with_import_edit="!$root.not_editable && check_roles([ 'model' ])"
	:not_able_for_delete="$root.not_editable || !check_roles([ 'model' ])"
	:without_context_menu="$root.not_editable"
	:attr_edit_many_validation="validation"
>
	<template v-slot:title><h3>Данные для расчета строительного объема</h3></template>

	<template v-slot:modal_dialogs>

		<addFloorHeight ref="add_element"/>

	</template>

</elements>

</template>

<script>

import api from "../../../../api"
import elements from "../../../elements"
import addFloorHeight from "./add"

export default
{
	components :
	{
		elements,
		addFloorHeight,
	},

	data()
	{
		return {

			service : "cadastral_floor_height",

			attrs :
			[
				{
					key : "functional_sub_group",
					label : "Код подгруппы",
					type : "str",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
				},
				{
					key : "floor_h",
					label : "Высота этажа, м",
					type : "number",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					editable : true,
				},
				{
					key : "underground_h",
					label : "Высота этажа подвала, м",
					type : "number",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					editable : true,
				},
				{
					key : "wall_k",
					label : "Коэффициент толщины стен",
					type : "number",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					editable : true,
				},
				{
					key : "coef",
					label : "Расчетный коэффициент (1/Коэффициент толщины стен)",
					type : "number",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					key : "overlap_h",
					label : "Толщина перекрытия, м",
					type : "number",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					editable : true,
				},
				{
					key : "source",
					label : "Источник информации",
					type : "src",
					sortable : true,
					visible : true,
					in_query : true,
					editable : true,
				},
			],

			validation :
			{
				floor_h : {
					check : (value) => api.check_number({ value, gt : 0 }),
					msg : "Больше 0",
					gt_min : 0
				},
				underground_h : {
					check : (value) => api.check_number({ value, gt : 0 }),
					msg : "Больше 0",
					gt_min : 0
				},
				wall_k : {
					check : (value) => api.check_number({ value, gt : 0 }),
					msg : "Больше 0",
					gt_min : 0
				},
				overlap_h : {
					check : (value) => api.check_number({ value, gt : 0 }),
					msg : "Больше 0",
					gt_min : 0
				}
			}

		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},
	}
}

</script>

